import { supabase } from '@foundation/utils/supabaseClient';
import { getActiveWorkspaceId } from '@header/activeWorkspace';
import type { MemoryStructure } from "../types/orgMemory";

const API_BASE = import.meta.env.VITE_API_URL || "http://localhost:3001";

async function getAuthHeaders(): Promise<Record<string, string>> {
  const { data: { session } } = await supabase.auth.getSession();
  const { data: { user } } = await supabase.auth.getUser();
  const orgId = getActiveWorkspaceId() ?? (user?.user_metadata?.organisation_id as string) ?? "";
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${session?.access_token ?? ""}`,
    "x-user-id": user?.id ?? "",
    "x-org-id": orgId,
  };
}

export const orgMemoryManagerService = {
  async getStructure(): Promise<MemoryStructure> {
    const headers = await getAuthHeaders();
    const res = await fetch(`${API_BASE}/api/revisr/org-memory-manager`, { headers });
    if (!res.ok) throw new Error(await res.text());
    return res.json() as Promise<MemoryStructure>;
  },

  async getCategories(): Promise<string[]> {
    const headers = await getAuthHeaders();
    const res = await fetch(`${API_BASE}/api/revisr/org-memory-manager/categories`, { headers });
    if (!res.ok) throw new Error(await res.text());
    return res.json() as Promise<string[]>;
  },

  async saveStructure(structure: MemoryStructure): Promise<void> {
    const headers = await getAuthHeaders();
    const res = await fetch(`${API_BASE}/api/revisr/org-memory-manager`, {
      method: "PUT",
      headers,
      body: JSON.stringify({ structure }),
    });
    if (!res.ok) throw new Error(await res.text());
  },
};
